import { createContext, useContext } from 'react';

export enum SubscriptionForeignResidenceStep {
  RegistryOffice = 0,
  Family = 1,
  Reesidence = 2,
  Attachments = 3,
}

export interface PraticaKey {
  cdEnte: string;
  tipoPratica: string;
  idAnnoPratica: number;
  pgPratica: number;
}

export interface AireSubscriptionState {
  currentStep: SubscriptionForeignResidenceStep;
  setCurrentStep: (step: SubscriptionForeignResidenceStep) => void;
  intestatarioData: unknown | null;
  setIntestatarioData: (data: unknown | null) => void;
  praticaKey: PraticaKey | null;
  setPraticaKey: (key: PraticaKey | null) => void;
  clearState: () => void;
}

const defaultValue: AireSubscriptionState = {
  currentStep: SubscriptionForeignResidenceStep.RegistryOffice,
  setCurrentStep: () => {
    return;
  },
  intestatarioData: null,
  setIntestatarioData: () => {
    return;
  },
  praticaKey: null,
  setPraticaKey: () => {
    return;
  },
  clearState: () => {
    return;
  },
};

export const AireSubscriptionContext = createContext<AireSubscriptionState>(defaultValue);

export const useAireSubscription = (): AireSubscriptionState => {
  return useContext(AireSubscriptionContext);
};
